import { AVAILABLE_LANGUAGES, ELanguages } from "../i18n/constants";
import { LANGUAGE_OPTIONS, LanguageOption } from "../config/constants";

export const languageOption = (lng: ELanguages | null | undefined):LanguageOption  => {
  if (!lng || !AVAILABLE_LANGUAGES.includes(lng)) {
    return LANGUAGE_OPTIONS[ELanguages.enUS];
  }
  return LANGUAGE_OPTIONS[lng];
};
